<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-2">
                        <az-input   
                            type="date"
                            v-model="filtro.referencia">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input   
                            type="select"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building-o fa-fw"
                            placeholder="Unidades..."
                            v-model="filtro.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input icon="fa fa-search fa-fw" v-model="filtro.search" @onEnter="load()">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="filtro.interno">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="incluir()" title="Registrar Admissão">
                                        <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="agendados()" title="Registrar Admissão de Paciente Agendado">
                                        <i class="fa fa-calendar-plus-o fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <importacao 
                                    v-else
                                    service="internacaos" 
                                    :parms="filtro"
                                    @refresh="load()">
                                    <template v-slot:button-pre>
                                        <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="incluir()" title="Registrar Admissão">
                                            <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                                        </button>
                                    </template>
                                </importacao>
                            </template>
                        </az-input>
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input 
                            type="checkbox-group"
                            label="Própria"
                            v-model="filtro.interno" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Hospital..."
                            icon="fas fa-clinic-medical fa-fw"
                            type="select"
                            optionsMode="aql"
                            service="centro_cirurgicos.index"
                            optionsData="id_centro_cirurgico" 
                            optionsDisplay="st_centro_cirurgico"
                            :optionsParm="{ ativos: true }"
                            v-if="!filtro.interno"
                            v-model="filtro.id_centro_cirurgico"  />

                        <az-input 
                            placeholder="Unidade de Internação..."
                            icon="fa-solid fa-bed fa-fw"
                            type="select"
                            optionsMode="aql"
                            :optionsName="'centro_custos.index.leito.' + filtro.id_unidade_operacao"
                            service="centro_custos.index"
                            optionsData="id_centro_custo" 
                            optionsDisplay="st_nome"
                            :optionsParm="{ 
                                ativos: true,
                                id_unidade_operacao: filtro.id_unidade_operacao,
                                leitos: true, 
                            }"
                            v-else
                            v-model="filtro.id_centro_custo"  />
                    </div>

                    <div class="col col-12 col-md-6">
                        <az-input 
                            icon="fa-solid fa-user-injured fa-fw"
                            placeholder="Selecionar paciente..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="paciente"
                            v-model="filtro.paciente" 
                            :optimized_ac="true" />
                    </div>
                </div>
                
                <div class="form-row mt-2" v-if="!$store.state.user.medico || $store.state.user.id_usuario == 1">
                    <div class="col col-12 col-md-6 d-flex flex-column">
                        <az-input icon="fas fa-user-md fa-fw" 
                            type="select" 
                            optionsMode="aql"
                            placeholder="Profissional..."
                            service="medicos.index"
                            optionsName="medicos-cadastro"
                            :optionsParm="{ ativos: true }"
                            optionsData="id_pessoa"
                            v-model="medico_adm"
                            @input="carregar_checkin()"  />
                    </div>
                </div>

            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>    

        <div v-if="lista_class && lista_class.length" class="mb-3">
            <a href="#" @click.prevent="selecionar_classe(classe)" v-for="(classe, icx) in lista_class" :key="icx">
                <span class="badge mr-1" :class="( classe == classe_selecionada ) ? 'badge-success' : 'badge-secondary'">
                    {{ classe }}
                </span>
            </a>
        </div>

        <escala-check-in ref="chk" :hide_empty="true" :medico="medico_adm" @refresh="load()" @filtrar="filtrar" />

        <az-empty-state icon="fas fa-bed" msg="Nenhum paciente identificado." v-if="!lista || !lista.length" />

        <div v-else>

            <div class="d-flex justify-content-between mb-2">
                
                <div>
                    <div>
                        <a href="#" @click.prevent="filtrar(status.valor)" v-for="(status, isx) in lista_status" :key="isx">
                            <span class="badge mr-1" :class="'badge-' + ( status.cor ? status.cor : 'secondary' )">
                                {{ status.valor }}: {{ status.count }} 
                            </span>
                        </a>
                    </div>
                </div>

                <div>
                    <a href="#" @click.prevent="filtrar('internado')">
                        <span class="badge badge-primary mr-1">
                            Internados: {{ lista.filter(item => !item.dt_alta).length }} 
                        </span>
                    </a>
                    <a href="#" @click.prevent="filtrar('alta')">
                        <span class="badge badge-danger mr-1">
                            Alta: {{ lista.filter(item => item.dt_alta).length }} 
                        </span>
                    </a>
                    <span class="badge badge-secondary">
                        Total: {{ lista.length }}
                    </span>

                    <span class="badge badge-secondary ml-1" v-if="dados.last_page > 1">
                        {{ dados.from }} - {{ dados.to }}  / {{ dados.total }}
                    </span>
                </div>
            </div>

            <div class="card carde mb-2 w3-animate-opacity" v-for="(item, index) in lista" :key="index">
                <div class="card-body py-1 px-2">
                    <div class="row">
                        <div class="col col-12 col-md-2">
                            <a href="#" class="card-link" @click.prevent="editar(item)">
                                #{{ item.id_internacao }}
                            </a>
                            <div v-if="item.dt_admissao"> 
                                <i class="fas fa-sign-in-alt fa-fw mr-2"></i>
                                {{ $util.getFormatDate(item.dt_admissao) }}
                                <span v-if="item.st_hora_admissao">
                                    {{ item.st_hora_admissao }}
                                </span>
                            </div>
                            <div v-if="item.dt_alta && item.dt_alta <= $util.hoje()"> 
                                <i class="fas fa-sign-out-alt fa-fw mr-2"></i>
                                {{ $util.getFormatDate(item.dt_alta) }}
                                <span v-if="item.st_hora_alta && item.st_hora_alta != '00:00'">
                                    {{ item.st_hora_alta }}
                                </span>
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div v-if="item.paciente">
                                <celula-dados-paciente :hor="{ marcacao: { 
                                        plano: item.plano,
                                        paciente: item.paciente
                                    }
                                }" />
                            </div>
                        </div>
                        <div class="col col-12 col-md-3">
                            <div v-if="item.local">
                                <div v-if="item.local.centro_custo && item.local.centro_custo.unidade_operacao">
                                    <i class="fas fa-clinic-medical fa-fw mr-2"></i>
                                    {{ item.local.centro_custo.unidade_operacao.search }}
                                </div>
                                <div v-if="item.local.centro_custo">
                                    <i class="fas fa-map-marker-alt fa-fw mr-2"></i>
                                    {{ item.local.centro_custo.search }}
                                </div>
                                <div v-if="item.local">
                                    <i class="fas fa-bed fa-fw mr-2"></i>
                                    {{ item.local.st_local }}
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="item.centro_cirurgico">
                                    <i class="fas fa-clinic-medical fa-fw mr-2"></i>
                                    {{ item.centro_cirurgico.search }}
                                </div>
                                <div v-if="item.st_unidade_internacao">
                                    <a href="#" @click.prevent="filtro.search = ( filtro.search == item.st_unidade_internacao ? '' : item.st_unidade_internacao )">
                                        <i class="fas fa-map-marker-alt fa-fw mr-2"></i>
                                        {{ item.st_unidade_internacao }}
                                    </a>
                                </div>
                                <div v-if="item.st_leito_nome">
                                    <i class="fas fa-bed fa-fw mr-2"></i>
                                    {{ item.st_leito_nome }}
                                </div>
                            </div>
                        </div>
                        <div class="col col-12 col-md-3 d-flex justify-content-between">
                            <div>
                                <div class="small text-muted">
                                    {{ item.st_motivo }}
                                </div>
                                <div v-if="item.js_classes && item.js_classes.length">
                                    <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in item.js_classes" :key="icx">
                                        <span class="badge badge-success mr-1">
                                            {{ classe }}
                                        </span>
                                    </a>
                                </div>
                            </div>

                            <!-- Menu de opções -->
                            <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <button class="dropdown-item" v-if="medico_adm || $store.state.user.medico" @click="registrar_atendimento(item)">
                                        Registrar Atendimento
                                    </button>

                                    <button class="dropdown-item" v-if="!item.dt_alta" @click="registrar_alta(item)">
                                        Registrar Alta
                                    </button>
                                    <button class="dropdown-item" v-else @click="cancelar_alta(item)">
                                        Cancelar Alta
                                    </button>

                                    <button class="dropdown-item" v-if="!item.dt_alta" @click="cancelar_admissao(item)">
                                        Cancelar Admissão
                                    </button>

                                    <div class="dropdown-divider"></div>

                                    <button class="dropdown-item" @click="printEtiqueta(item)">
                                        Emitir Etiqueta
                                    </button>

                                    <button class="dropdown-item" @click="novoDocumento(item)">
                                        Emitir Documento
                                    </button>

                                    <button class="dropdown-item" @click="chamar(item)">
                                        Chamar Paciente
                                    </button>

                                    <button class="dropdown-item" @click="abrir_conta(item)">
                                        Lançamentos
                                    </button>

                                    <template v-if="relatorios && relatorios.length">
                                        <div class="dropdown-divider"></div>
                                        <button class="dropdown-item" @click="abrir_relatorio(item, relatorio)" v-for="(relatorio, irx) in relatorios" :key="irx">
                                            <i class="fa-regular fa-file-lines mr-2"></i>
                                            {{ relatorio.title }}
                                        </button>
                                    </template>

                                    <div class="dropdown-divider"></div>
                                    
                                    <button class="dropdown-item" @click="log_intern(item)">
                                        Log
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer py-1 px-2" v-if="item.marcacoes && item.marcacoes.length">
                    <div v-for="(marcacao, imx) in item.marcacoes" :key="imx" class="small d-flex justify-content-between">

                        <div>

                            <a href="#" @click.prevent="editar_marcacao(marcacao)" class="mr-3" title="Editar Marcação">
                                <i class="fa-solid fa-circle-info fa-fw text-info"></i>
                            </a>

                            <a href="#" @click.prevent="$refs.doc_pre_atend.abrir(marcacao)" class="mr-3" title="Pré-Atendimento">
                                <i class="fa-solid fa-p"></i>
                            </a>
                            
                            <a href="#" @click.prevent="novoDocumento(marcacao)" class="mr-3" title="Emitir Documento">
                                <i class="fa-solid fa-file-circle-plus"></i>
                            </a>

                            <a href="#" @click.prevent="atender(marcacao)" class="card-link"> 

                                <i class="fa fa-play mx-2" aria-hidden="true"></i>

                                {{ $util.getFormatDate(marcacao.dt_inicio) }}
                                {{ marcacao.dt_inicio.substr(11,5) }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>

                                <span v-if="marcacao.id_atendimento">
                                    #{{ marcacao.id_atendimento }}
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                </span>

                                <!-- Pacote de Sessões -->
                                <span v-if="marcacao.procedimento.id_classe_procedimento == 17 && marcacao.atendimento && marcacao.atendimento.atendimento_procedimento && marcacao.atendimento.atendimento_procedimento.id_atendimento_pacote" class="mr-1" title="Pacote de Sessão">
                                    <i class="fa-solid fa-layer-group"></i>
                                </span>
                                
                                {{ marcacao.procedimento.search }}

                                <span class="text-muted ml-2">
                                    {{ marcacao.medico.search }}
                                </span>

                                <span v-if="marcacao.recepcao">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ marcacao.recepcao.search }}
                                </span>

                            </a>

                            <i  :class="( marcacao.sinalizador_atendimento 
                                    ? ( marcacao.sinalizador_atendimento.st_icon ? marcacao.sinalizador_atendimento.st_icon : 'fas fa-flag' ) + ' text-' + marcacao.sinalizador_atendimento.st_cor 
                                    : 'fas fa-question' ) + ' ml-2'" 
                                aria-hidden="true" v-if="marcacao.sinalizador_atendimento"></i>

                            <a href="#" @click.prevent="filtrar(marcacao.item_status.valor)">
                                <span class="badge ml-2" :class="'badge-' + marcacao.item_status.cor" v-if="marcacao.item_status">
                                    {{ marcacao.item_status.valor }}
                                </span>
                            </a>

                        </div>

                        <button type="button" class="btn btn-sm btn-link p-0" :disabled="$store.state.loading" @click.prevent="registrar_atendimento_marcacao(item, marcacao)" v-if="!marcacao.id_atendimento && marcacao.procedimento.id_classe_procedimento == 2">
                            <strong>
                                Registrar Atendimento
                            </strong>
                        </button>
                    </div>
                </div>
            </div>

            <br><br><br><br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
                <div class="d-flex">
                    <paginate
                        class="mb-0"
                        :page-count="dados.last_page"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </div>
            </nav>

            <pre class="mt-3 alert alert-warning" v-if="false">{{ dados }}</pre>
        </div>

        <edicao-internacao ref="edit_intern" @refresh="load()" />

        <!-- Modal Seleção Recepção -->
        <div class="modal fade" id="selecaoRecepcaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Recepção</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="list-group" v-if="rececpcoes && item">
                            <button type="button" class="list-group-item list-group-item-action" v-for="(rec, irx) in rececpcoes" :key="irx"
                                @click="registrar_atendimento_marcacao(item, item.marcacao, rec, false)">
                                {{ rec.search }}
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Registro de Atendimento -->
        <div class="modal fade" id="registroModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecione o Procedimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="referencia" class="alert d-flex justify-content-between" :class="referencia < $util.hoje() ? 'alert-danger' : 'alert-info'">
                            <div>
                                Data:
                                <strong>{{ $util.getFormatDate(referencia) }}</strong>
                            </div>
                            <div v-if="referencia < $util.hoje()">
                                <i class="fa-solid fa-triangle-exclamation mr-2"></i>
                                Retroativo
                            </div>
                        </div>

                        <template v-if="item">
                            <div class="card">
                                <div class="card-body">
                                    <celula-dados-paciente :hor="{ 
                                            marcacao: { 
                                                plano: item.plano,
                                                paciente: item.paciente
                                            }
                                        }" />
                                </div>
                            </div>
                        </template>

                        <div v-if="medico_adm_info" class="alert alert-secondary">
                            <i class="fa-solid fa-user-doctor mr-3"></i>
                            {{ medico_adm_info.search }}
                        </div>

                        <div class="mb-3">
                            <az-input
                                sizing="sm"
                                icon="fa fa-search fa-fw"
                                placeholder="Pesquisar..."
                                :edicao="!novo_procedimento"
                                v-model="search_procedimento" />
                        </div>

                        <az-empty-state v-if="!exibir_procedimentos || !exibir_procedimentos.length" msg="Nenhum procedimento identificado" icon="fa fa-play" />

                        <div class="list-group" v-else-if="!novo_procedimento">
                            <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between"
                                v-for="(proc, ipx) in exibir_procedimentos" :key="ipx"
                                :disabled="$store.state.loading"
                                @click="selecionar_novo_procedimento(proc.procedimento)">
                                <div>
                                    {{ proc.procedimento.search }} 
                                </div>
                                <div>
                                    <span class="badge badge-danger" v-if="( proc.procedimento && proc.procedimento.calc_valor && !proc.procedimento.id_pacote && proc.procedimento.calc_valor && !proc.procedimento.calc_valor.id_item_tabela )" title="Item não presente em tabela de preço.">
                                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                    </span>
                                    <span class="badge badge-secondary ml-2" v-if="proc.procedimento.pacote && proc.procedimento.pacote.fl_combo" title="Combo">
                                        C
                                    </span>
                                </div>
                            </button>
                        </div>

                        <div v-else>
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    {{ novo_procedimento.search }}
                                </div>
                                <div>
                                    <a href="#" @click.prevent="novo_procedimento = null; rececpcoes = [];">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>

                            <div class="form-row mb-3" v-if="novo_procedimento.pacote && novo_procedimento.pacote.fl_combo && novo_procedimento.pacote.fl_combo_pacote && novo_procedimento.pacote.fl_definir_cobertura">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        sizing="sm"
                                        type="date"
                                        icon="fas fa-greater-than-equal fa-fw"
                                        required
                                        :validate="validate"
                                        v-model="novo_procedimento.data_inicio" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        sizing="sm"
                                        type="date"
                                        icon="fas fa-less-than-equal fa-fw"
                                        required
                                        :validate="validate"
                                        v-model="novo_procedimento.data_fim" />
                                </div>
                            </div>

                            <div class="list-group" v-if="rececpcoes && rececpcoes.length">
                                <button type="button" class="list-group-item list-group-item-action"
                                    v-for="(recep, ipx) in rececpcoes" :key="ipx"
                                    :disabled="$store.state.loading"
                                    @click="salvar_novo_atendimento(recep)">
                                    {{ recep.search }}
                                </button>
                            </div>

                            <div v-else>
                                <az-empty-state msg="Nenhuma recepção identificada." />
                            </div>

                        </div>

                        <pre v-if="false">{{ lista_procedimentos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"
                                v-if="$store.state.loading">
                            </span>
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Documentos -->
        <documento ref="documento" :recepcao="true" refresh="imprimir_documento" />

        <!-- Pré Atendimento -->
        <documento-pre-atendimento ref="doc_pre_atend" />

        <!-- Emitir Etiqueta -->
        <emitir-etiqueta ref="etiqueta" />

        <!-- Conta Lançamentos -->
        <conta-lancamentos ref="conta" :editar_atend="editar_atendimento"/>

        <!-- Editar Atendimento -->
        <iniciar-atendimento ref="ini_atd" @refresh="load()" />

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import Importacao from '../../cadastros/shared/Importacao.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import EdicaoInternacao from './EdicaoInternacao.vue';
import EscalaCheckIn from '../escalas/EscalaCheckIn.vue';
import Documento from '../consultorio/Documento.vue';
import EmitirEtiqueta from '../../shared/EmitirEtiqueta.vue';
import DocumentoPreAtendimento from '../../shared/DocumentoPreAtendimento.vue';
import ContaLancamentos from './ContaLancamentos.vue'; 
import IniciarAtendimento from '../recepcao/IniciarAtendimento.vue';

export default {
    data() { 
        return { 
            dados: null, 
            validate: false, 
            filtro: { 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'), 
                search: "",
                internados: true, 
                referencia: this.$util.hoje(), 
                interno: false, 
                id_centro_cirurgico: "", 
                id_centro_custo: "", 
                paciente: "", 
            }, 
            novo_procedimento: null, 
            rececpcoes: [], 
            lista_procedimentos: null, 
            item: null, 
            escala: null, 
            medico_adm: "", 
            classe_selecionada: "", 
            pagina: 1, 
            referencia: "", 
            lista_medicos: [], 
            medico_adm_info: null,
            relatorios: [], 
            search_procedimento: "", 
        }
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        Importacao,
        CelulaDadosPaciente,
        EdicaoInternacao, 
        EscalaCheckIn, 
        Documento,
        EmitirEtiqueta, 
        DocumentoPreAtendimento,
        ContaLancamentos, 
        IniciarAtendimento, 
    },

    computed: { 
        lista_status: function () { 
            return _.map(
                _.groupBy(
                    _.flatMap(this.lista, item => item.marcacoes)
                        .map(item => { 
                            return item.item_status;
                        }
                    ),
                    'valor'
                ),
                items => { 
                    return { 
                        ...items[0],
                        count: items.length
                    }
                }
            );
        },

        lista: function () { 
            if ( !this.dados || !this.dados.data )
                return [];

            let reg = this.$util.getregex(this.filtro.search);
            
            return this.dados.data.filter (item => { 
                    return ( !this.filtro.search || reg.test(JSON.stringify(item)) )
                        && ( !this.classe_selecionada || ( item.js_classes && item.js_classes.includes(this.classe_selecionada) ) );
                });
        },

        lista_class: function () { 
            if ( !this.dados ) 
                return [];
                
            return _.orderBy(
                _.uniq(
                    this.dados.data.filter (item => item.js_classes)
                        .flatMap(item => item.js_classes)
                )
            );
        },

        exibir_procedimentos: function () { 
            if ( !this.search_procedimento )
                return this.lista_procedimentos;

            let reg = this.$util.getregex(this.search_procedimento);

            return this.lista_procedimentos.filter(item => reg.test(item.procedimento.search));
        }
    },

    methods: { 
        log_intern (item) { 
            this.$util.logAudit('internacao', item.id_internacao);
        },

        editar_atendimento (id_atendimento) { 
            $('.modal').modal('hide');

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'show',
                parms: { 
                    id: id_atendimento,
                    by_atendimento: true, 
                },
                loadTo: (marcacao) => { 
                    if ( marcacao && marcacao.id_marcacao ) { 
                        this.$refs.ini_atd.abrir(marcacao, 2);
                    }
                }
            });
        },

        abrir_conta (internado) { 
            this.$refs.conta.abrir(internado.id_internacao);
        },

        abrir_relatorio (internado, relatorio) { 
            let parms = { 
                id_internacao: internado.id_internacao,
                id_atendimento: _.uniq(internado.marcacoes.filter(m => m.id_atendimento).map(m => m.id_atendimento)),
                id_marcacao: _.uniq(internado.marcacoes.filter(m => m.id_marcacao).map(m => m.id_marcacao)),
            };

            console.log('abrir_relatorio', relatorio, parms);

            this.$root.$children[0].$refs.relatmodal.abrir({ id: relatorio.id, ...parms, inmodal: true, linked: true });
        },

        printEtiqueta (internacao) {
            this.$refs.etiqueta.emitir('internacao', internacao);
        },

        paginar (pagina) {
            this.pagina = pagina;
            this.load(false);
        },

        selecionar_classe (classe) { 
            if ( this.classe_selecionada == classe ) { 
                this.classe_selecionada = "";
            } else { 
                this.classe_selecionada = classe;
            }
        },

        novoDocumento(marcacao) {
            this.$refs.documento.novoDocumento(marcacao);
        },

        editar_marcacao (marcacao) { 
            this.$root.editar_marcacao(marcacao.id_marcacao, () => { 
                this.load();
            });
        },

        cancelar_admissao (item) { 

            if ( !confirm('Confirmar cancelar a admissão de ' + item.paciente.search + '?') ) { 
                return; 
            }

            this.$util.atualizar(this, { 
                service: 'internados',
                func: 'cancelar_admissao',
                dados: { 
                    id_internacao: item.id_internacao, 
                },
                toast: true, 
                callback: () => { 
                    this.load();
                }
            })

        },

        cancelar_alta (item) { 

            if ( !confirm('Confirmar cancelar a alta de ' + item.paciente.search + '?') ) { 
                return; 
            }

            this.$util.atualizar(this, { 
                service: 'internados',
                func: 'cancelar_alta',
                dados: { 
                    id_internacao: item.id_internacao, 
                },
                toast: true, 
                callback: () => { 
                    this.load();
                }
            })

        },

        registrar_alta(item) { 
            this.$refs.edit_intern.abrir_alta(item.id_internacao);
        },

        agendados () { 
            this.$refs.edit_intern.agendados();
        },

        carregar_checkin() { 
            this.$nextTick(() => { 
                this.$refs.chk.load();
            });
        },
        filtrar(classe) { 
            if ( this.filtro.search == '\x22' + classe + '\x22' ) { 
                this.filtro.search = ''
            } else { 
                this.filtro.search = '\x22' + classe + '\x22'
            }
        },

        verPep (marcacao) {
            $('[data-toggle="tooltip"]').tooltip('hide');
            this.$router.push({path: '/consultorio/' + marcacao.id_paciente});
        },

        verRes (marcacao) { 
            $('[data-toggle="tooltip"]').tooltip('hide');

            if ( marcacao.atendimento ) { 
                if ( this.$store.state.user.medico ) { 
                    this.$router.push({path: '/internacao/atendimento/res/' + marcacao.atendimento.id_atendimento});
                } else { 
                    this.$util.abrir_atendimento(this, marcacao.atendimento.id_atendimento);
                }
            } else { 
                this.$router.push({
                    name: 'recepcao', 
                    params: { 
                        id_marcacao: marcacao.id_marcacao 
                    }
                });
            }
        },

        atender (marcacao) { 
            // this.verPep(marcacao);
            this.verRes(marcacao);
        },

        registrar_atendimento_marcacao(internacao, marcacao, recepcao = null, confirmar = false) { 

            $('.modal').modal('hide');

            if ( !recepcao ) { 
                this.item = _.cloneDeep(internacao);
                this.selecionar_novo_procedimento(marcacao.procedimento, marcacao);
                return;
            }

            if ( confirmar && !confirm('Confirmar regitrar o atendimento de ' + internacao.paciente.st_nome + '?') )
                return;

            this.$util.atualizar(this, { 
                service: 'internados',
                func: 'registrar_atendimento',
                dados: { 
                    id_internacao: internacao.id_internacao,
                    id_marcacao: marcacao.id_marcacao, 
                    id_recepcao: recepcao.id_recepcao,
                    block_atender: true, 
                },
                toast: true, 
                reload: true, 
            });

        },

        registrar_atendimento (item) { 

            this.item = _.cloneDeep(item);
            
            this.validate = false;
            this.lista_procedimentos = null;
            this.novo_procedimento = null; 

            this.$store.commit('loading', true);
            
            $('[data-toggle="tooltip"]').tooltip("dispose");
            $('#registroModal').modal('show');

            if ( !this.$store.state.user.medico && this.medico_adm ) { 

                if ( this.lista_medicos[this.medico_adm] ) { 

                    this.medico_adm_info = this.lista_medicos[this.medico_adm];

                } else { 

                    this.$util.loadItem(this, { 
                        service: 'medicos',
                        func: 'show',
                        parms: { id: this.medico_adm }
                    })
                    .then(res => { 
                        this.lista_medicos[this.medico_adm] = res;
                        this.medico_adm_info = res;
                    });

                }
            }

            this.$util.loadItem(this, { 
                service: 'medico_procedimento_unidades',
                func: 'index',
                parms: { 
                    id_medico: this.medico_adm ? this.medico_adm : this.$store.state.user.id_pessoa, 
                    ativos: true, 
                    internados: true,
                    id_operadora: item.plano.id_operadora, 
                    id_plano: item.plano.id_plano, 
                    id_unidade_operacao: item.id_unidade_operacao, 
                }
            })
            .then(res => { 
                this.lista_procedimentos = res;
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        },

        selecionar_novo_procedimento (procedimento, marcacao = null) { 
            if ( procedimento && procedimento.calc_valor && !procedimento.id_pacote && procedimento.calc_valor && !procedimento.calc_valor.id_item_tabela ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Procedimento '" + procedimento.st_procedimento + "' não presente na tabela de preço da operadora.",
                    life: 5000
                });
                return;
            }

            this.novo_procedimento = procedimento;

            this.$util.load(this, { 
                service: 'internados',
                func: 'listar_recepcao', 
                parms: { 
                    id_internacao: this.item.id_internacao,
                    id_procedimento: procedimento.id_procedimento, 
                },
                loadTo: res => { 
                    this.rececpcoes = res.lista;

                    if ( marcacao ) { 
                        if ( this.rececpcoes.length == 1 ) { 
                            this.registrar_atendimento_marcacao(this.item, marcacao, this.rececpcoes[0], true);
                        } else { 
                            this.item.marcacao = marcacao;
                            $('#selecaoRecepcaoModal').modal('show');
                        }
                    }
                }
            });
        },

        salvar_novo_atendimento (recep) { 

            this.$util.atualizar(this, { 
                service: 'internados',
                func: 'novo_atendimento',
                dados: { 
                    id_internacao: this.item.id_internacao,
                    id_procedimento: this.novo_procedimento.id_procedimento, 
                    id_recepcao: recep.id_recepcao,
                    referencia: this.referencia,
                    id_medico: this.medico_adm,
                    pacote_inicio: this.novo_procedimento.data_inicio,
                    pacote_fim: this.novo_procedimento.data_fim,
                },
                modal: 'registroModal',
                toast: true, 
                reload: true, 
                callback: res => { 
                    console.log('atualizar', res);
                }
            });

        },

        incluir () { 
            this.$refs.edit_intern.admitir(null, this.filtro);
        },

        editar (item) { 
            this.$refs.edit_intern.abrir(item.id_internacao);
        },

        chamar(item) { 

            if ( !confirm('Confirma chamar o paciente ' + item.paciente.st_nome + '?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'chamada_painel',
                func: 'chamar',
                dados: { 
                    id_paciente: item.id_paciente, 
                    id_unidade_operacao: item.id_unidade_operacao, 
                    id_recepcao: this.$util.getCookie('id_recepcao'),
                    local: this.$util.getCookie('local-chamada'),
                    block_painel: this.$util.getCookie('nao-enviar-painel'),
                },
                toast: true, 
                msg: 'Chamada realizada', 
            });

        },


        load() { 
            if ( this.filtro.id_unidade_operacao != this.$util.getCookie('id_unidade_operacao') ) { 
                this.$util.setCookie('id_unidade_operacao', this.filtro.id_unidade_operacao);
            }

            this.$util.setCookie('int-pr', this.filtro.interno ? 'S' : 'N', 365);
            this.$util.setCookie('int-cc', this.filtro.id_centro_custo, 365);

            this.referencia = this.filtro.referencia;

            this.$util.load(this, { 
                service: 'internacaos',
                parms: { 
                    ...this.filtro,
                    size: 1000, 
                    page: this.pagina
                }
            });
        }
    },

    beforeMount () { 

        this.filtro.interno = this.$util.getCookie('int-pr') == 'S' ? true : false;
        
        this.filtro.id_centro_custo = this.$util.getCookie('int-cc')
            ? this.$util.getCookie('int-cc')
            : "";

        //

        let pagina = 'internacao';

        let info = _.get(this.$store.state.relatorios_linkados, pagina);

        if ( info ) { 
            this.relatorios = info; 
            return;
        } 

        this.$util.loadItem(this, {
            service: "relatorios",
            func: "pagina",
            parms: {
                pagina: pagina
            }
        })
        .then(res => {
            let info = {};

            this.relatorios = res.map (item => item._query);

            info[pagina] = this.relatorios;

            this.$store.commit("setRelatorioLinkado", info);
        });
        
    },

    mounted() { 

        this.$store.commit("setBreadcrumb", [
            { name: "Internação", path: "/internacao/internados" },
            { name: "Internados", path: "/internacao/internados" }
        ]);

        this.$util.loadItem(this, { 
            service: 'plantao_escalas',
            func: 'index_internacao',
            parms: { 
                checkin: true,
            }
        })
        .then(res => { 
            // console.log(res);

            if ( res.length == 1 ) { 
                this.escala = res;

                this.filtro.referencia = res[0].dt_escala;
                this.filtro.id_unidade_operacao = res[0].agenda.id_unidade_operacao;
                this.filtro.id_centro_cirurgico = res[0].agenda.id_centro_cirurgico;
            }
        })
        .finally(() => { 
            this.load();
        });

    },
}
</script>